<template>
  <div class="sidebar">
    <div class="sidebar-header" >
      <h3>服务平台</h3>
    </div>
    <el-menu
      :default-active="activeMenu"
      text-color="#333"
      active-text-color="#165DFF"
      ref="menu"
      @select="handleMenuSelect"
    >
      <template v-for="item in menuItems">
        <!-- 有子菜单的情况 -->
        <el-submenu
          v-if="item.childrenList && item.childrenList.length"
          :key="item.menuCode"
          :index="item.menuCode"
        >
          <template slot="title">
            <span class="sidebar-menu-icon" aria-hidden="true">
              <el-image v-if="getMenuIcon(item)" :src="getMenuIcon(item)"></el-image>
              <i v-else class="el-icon-folder-opened"></i>
            </span>
            <span>{{ item.menuName }}</span>
          </template>
          <el-menu-item
            v-for="child in item.childrenList"
            :key="child.menuCode"
            :index="child.menuUrl"
          >
            <span slot="title">{{ child.menuName }}</span>
          </el-menu-item>
        </el-submenu>

        <!-- 无子菜单的情况 -->
        <el-menu-item
          v-else
          :key="item.menuCode"
          :index="item.menuUrl"
        >
          <span class="sidebar-menu-icon" aria-hidden="true">
            <el-image v-if="getMenuIcon(item)" :src="getMenuIcon(item)"></el-image>
            <i v-else :class="item.menuCode === 'invoiceManagement' ? 'el-icon-tickets' : 'el-icon-menu'"></i>
          </span>
          <span slot="title">{{ item.menuName }}</span>
        </el-menu-item>
      </template>
    </el-menu>
    <div v-if="menuError" class="menu-feedback" role="alert">
      <span>{{ menuError }}</span>
      <el-button type="text" size="small" :loading="menuLoading" @click="getMenuItems">重新加载</el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { activeServiceMenu, flattenServiceMenus, activateServiceMenu } from '@/utils/serviceMenus'

export default {
  computed: {
    ...mapState('serviceNavigation', { menuItems: 'menus', menuError: 'menuError', menuLoading: 'menuLoading', selectionRevision: 'selectionRevision' }),
    activeMenu() {
      const menu = activeServiceMenu(this.menuItems, this.$route)
      return menu ? menu.menuUrl : this.$route.path
    },
    activeParent() {
      const menu = activeServiceMenu(this.menuItems, this.$route)
      return menu && menu.parentCode || ''
    }
  },
  watch: {
    activeParent: { immediate: true, handler() { this.expandActiveParent() } },
    selectionRevision() { this.expandActiveParent() }
  },
  methods: {
    getMenuItems() { this.$store.dispatch('serviceNavigation/loadMenus', true) },
    expandActiveParent() {
      this.$nextTick(() => {
        if (this.activeParent && this.$refs.menu) this.$refs.menu.open(this.activeParent)
      })
    },
    isMenuActive(item) {
      return item.menuUrl === this.activeMenu || item.childrenList.some(child => child.menuUrl === this.activeMenu)
    },
    getMenuIcon(item) {
      if (item.menuCode === 'invoiceManagement') return null
      const prefix = this.isMenuActive(item) ? 'activity' : ''
      try {
        return require(`@/static/images/service-icon/slideBar/${prefix}${item.menuCode}.png`)
      } catch (e) { return null }
    },
    handleMenuSelect(index) {
      const menu = flattenServiceMenus(this.menuItems).find(item => item.menuUrl === index)
      if (menu && menu.menuCode === 'exit') {
        this.$store.dispatch('userOutLogin').then(() => this.$router.push('/public/service/login'))
      } else if (activateServiceMenu(this.$router, menu)) {
        this.$store.commit('serviceNavigation/TOUCH_MENU')
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.el-menu {
  border-right: none;
}
.sidebar-menu-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 13px;
  height: 13px;
  margin-right: 10px;
  vertical-align: middle;
  color: #666;
  .el-image { width: 13px; height: 13px; }
  i {
    width: 13px;
    margin: 0;
    font-size: 13px;
    line-height: 13px;
    color: inherit;
  }
}
.el-menu-item.is-active .sidebar-menu-icon,
.el-submenu.is-active .sidebar-menu-icon {
  color: #165DFF;
}
.menu-feedback { padding: 8px 16px; font-size: 12px; color: #606266; }
.menu-feedback .el-button { margin-left: 8px; }
.sidebar {
  width: 200px;
  min-height: 80vh;
  box-sizing: border-box;
  position: relative;
  flex-shrink: 0;

  background-image: url('../static/images/service-icon/leftMenu.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  border: 1px solid #E4E4E4; // 边框
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08); // 阴影
  border-radius: 8px; // 圆角
  transition: all 0.3s ease;
  .sidebar-header {
    height: 60px;
    line-height: 60px;
    padding-left: 20px;
    background: #045ad5;
    coLor: #fff;
    border-bottom: 1px solid #E4E4E4;
    h3 {
      margin: 0;
      padding: 0;
    }
  }
  .el-menu {
    /* 禁用菜单项的hover背景色 */
    background: transparent;
    .el-menu-item {
      &:hover {
        background-color: transparent !important;
      }
      
      /* 激活状态样式 */
      &.is-active {
        background-color: rgba(22, 93, 255, 0.1);
      }
    }
  }
}
</style>
